// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"5aef0648","673":"c5a1ca54","766":"d908255d","767":"1d0ba02c","899":"9a4836bb"}[chunkId] + ".chunk.css";
};